import React from "react";
import { Marker } from "react-static-google-map";
import { Resource } from "../../types/resource";

type Props = {
  resource: Resource;
};

const HeavyMachineMarker: React.FC<Props> = ({ resource }) => {
  return <Marker location={{ lat: resource.lat, lng: resource.lon }} />;
};

export default HeavyMachineMarker;
